import React from 'react';
const IconNavAppsFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11 3H3V11H11V3Z" fill="#2D2E2E"/>
<path d="M11 13H3V21H11V13Z" fill="#2D2E2E"/>
<path d="M21 13H13V21H21V13Z" fill="#2D2E2E"/>
<path d="M18 6V3H16V6H13V8H16V11H18V8H21V6H18Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconNavAppsFill;